import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'BlogRichText',
})(({ breakpoints, spacing, typography }) => ({
  blogRichText: {
    margin: `${spacing(1)} 0`,

    [breakpoints.up('md')]: {
      margin: `${spacing(2)} 0`,
      padding: `0 ${spacing(5)}}`,
    },
  },
  richTextParagraph: {
    wordBreak: 'break-word',
  },
  richTextList: {
    listStylePosition: 'inside',
    padding: 0,
    '& p': {
      display: 'inline',
    },
  },
  richTextContent: {
    margin: `${spacing(2)} 0`,

    [breakpoints.up('sm')]: {
      padding: `0 ${typography.pxToRem(20)}}`,
    },
    [breakpoints.up('md')]: {
      padding: `0 ${typography.pxToRem(44)}}`,
    },
  },
  fixedGrid: {
    [breakpoints.up('lg')]: {
      margin: 0,
    },
  },
}));

export default useStyles;
